import { autoinject, transient } from "aurelia-dependency-injection";
import { UserSecurityInfoModel } from "../../../models/authentication/token.models";
import { UserClientService } from "../../../services/authentication/user-client.service";
import { TokenClient } from "../../../services/authentication/token-client.service";
import { EventAggregator } from "aurelia-event-aggregator";
import { Messages } from "../../../configuration/event-messages.constants";
import { RouteConfig, Router } from "aurelia-router";
import { RoutesService } from "../../../routes/routes";
import * as Enumerable from "linq";
import { Disposable } from "aurelia-framework";
import { BindingSignaler } from "aurelia-templating-resources";
import '../../../helpers/scroll-into-view';
import { CacheClientService } from "@rightship-tech/common-ui/services/basic/client-caching.service";

//Load styles
require("../../../styles/inspection/core-inspection.scss");

@autoinject()
@transient()
export class LayoutInspection {

    private router: Router;
    private subscriptions: Disposable[] = [];
    public selectedRoute: RouteConfig = { route: null };
    public routes: RouteConfig[] = [];
    public config: any;
    public settingsDropdownOpen: boolean;
    public documentClick: EventListenerOrEventListenerObject
    public contentShowing: boolean;

    constructor(private userClientService: UserClientService, private tokenClient: TokenClient, 
        private cacheClient: CacheClientService, private eventAggregator: EventAggregator,
        private routesService: RoutesService, private bindingSignaler: BindingSignaler) {

        this.documentClick = e => {
            if (!(<any>e).propagationStopped) {
                this.settingsDropdownOpen = false;
                eventAggregator.publish(Messages.documentClick, { source: "document" });
            }
        };

        this.subscriptions.push(eventAggregator.subscribe('show-date-picker', () => {
            this.showDatePicker = true;
        }));

        this.subscriptions.push(eventAggregator.subscribe('hide-date-picker', () => {
            this.showDatePicker = false;
        }));
    }

    public get user(): UserSecurityInfoModel {
        return this.userClientService.currentUser;
    }

    public openSettingsDropdown(event) {
        event.stopPropagation();
        this.settingsDropdownOpen = !this.settingsDropdownOpen;
    }

    public showDatePicker: boolean = false;
    attached(){
        document.addEventListener("click", this.documentClick);

        this.subscriptions.push(this.eventAggregator.subscribe("router:navigation:complete",
            () => {
                //Check if navigation was cancelled
                const routesList = this.router.routes.concat(this.routes);
                this.selectedRoute = Enumerable.from(routesList).where(x => x != null && x.name != null)
                    .firstOrDefault(x => this.router.currentInstruction && x.name == this.router.currentInstruction.config.name);

                this.bindingSignaler.signal('refresh-is-active');
            }));
    }

    detached() {
        document.removeEventListener("click", this.documentClick);
    }

    configureRouter(config, router: Router) {
        this.router = router;
        this.config = config;
        config.title = "RightShip Inspection";
        config.options.pushState = true;
        config.options.hashChange = true;
        config.options.root = "/inspection-client";
        this.routes = this.getRoutes();
        config.map(this.routes);
        config.mapUnknownRoutes({ redirect: '/inspection-client' });
        router.configure(config);
    }

    public getRoutes(): RouteConfig[] {
        let section = Enumerable.from(this.routesService.getInspectionClientRoutes()).selectMany(x => x.routes).toArray();

        if (section) {
            section.forEach(x => x.nav = true);
        }

        if (!section) {
            section = [];
        }

        return section;
    }

    navigate(event, route: RouteConfig) {
        event.stopPropagation();
        this.selectedRoute = route;
        this.router.navigate(Array.isArray(route.route)? route.route[0]:route.route);
    }

    get getSection() {
        if(this.selectedRoute) {
            const section = this.routesService.getInspectionClientRoutes().filter(x=> x.routes.filter(a => a.name == this.selectedRoute.name).length > 0)[0];
            return section? section.title : "";
        }

        return "";
    }


    onLogOut(): void {
        if (this.tokenClient) {
            this.tokenClient.logout().then(() => {                        
                //clear tab cache
                this.cacheClient.remove("tabs-activities");
            });
        }
    }
}
